import './footerSection.scss';
import React, { useState } from 'react';
import { scrollToElement } from '../../utils';

import phoneIconPath from '../../images/icons/phone-icon.svg';
import emailIconPath from '../../images/icons/email-icon.svg';
import youtubeIconPath from '../../images/icons/youtube-icon.svg';
import twitterIconPath from '../../images/icons/twitter-icon.svg';
import locationIconPath from '../../images/icons/location-icon.svg';
import facebookIconPath from '../../images/icons/facebook-icon.svg';
import instagramIconPath from '../../images/icons/instagram-icon.svg';
import logoIconPath from '../../images/icons/repair-pros-logo-icon.svg';

export const FooterSection = () => {
  const [navItems] = useState<Array<{ name: string; path: string; id: string }>>([
    { id: '#home', name: 'Home', path: '/' },
    { id: '#our-values', name: 'Our Values', path: '/' },
    { id: '#services', name: 'Services', path: '/' },
    { id: '#repair-pro-tips', name: 'Repair Tips', path: '/' },
    { id: '#faq', name: "FAQ's", path: '/' },
  ]);

  return (
    <div className={'footer'}>
      <div className={'footer__wrapper'}>
        <div className={'footer__wrapper__left'}>
          <div className={'footer__wrapper__left__top'}>
            <div className={'footer__wrapper__left__top__image'}>
              <img src={logoIconPath} alt={'Repair Pros Logo'} />
            </div>
            <div className={'footer__wrapper__left__top__nav'}>
              <span style={{ color: 'grey' }}>Content</span>
              <div
                className={'footer__wrapper__left__top__nav__items'}
                style={{ display: 'flex', flexWrap: 'wrap' }}
              >
                {navItems.map(({ name, id }) => (
                  <div
                    key={name + id}
                    className={'footer__wrapper__left__top__nav__items__item'}
                    onClick={() => scrollToElement(id)}
                    style={{ whiteSpace: 'nowrap', marginRight: '10px' }} // Adjust margin as needed
                  >
                    {name}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={'footer__wrapper__left__bottom'}>
            <p>© {new Date().getFullYear()} Repair Pros Limited. All rights reserved</p>
            <p>
              <span>Opening Hours:</span> Monday - Friday 8:30AM - 5PM
            </p>
          </div>
        </div>
        <div className={'footer__wrapper__right'}>
          <div className={'footer__wrapper__right__contact'}>
            <span>Social Media Links</span>
            <div className={'footer__wrapper__right__contact__container'}>
              <div className={'footer__wrapper__right__contact__container__item'}>
                <div className={'footer__wrapper__right__social__container'}>
                  <img src={facebookIconPath} alt={'facebook icon'} />
                  <img src={youtubeIconPath} alt={'youtube icon'} />
                  <img src={twitterIconPath} alt={'twitter icon'} />
                  <img src={instagramIconPath} alt={'instagram icon'} />
                </div>{' '}
              </div>
              <div className={'footer__wrapper__right__contact__container__item'}>
                <div className={'footer__wrapper__right__contact__container__item__left'}>
                  <img src={phoneIconPath} alt={'facebook icon'} />
                </div>
                <div className={'footer__wrapper__right__contact__container__item__right'}>
                  +1 (876) 802-4187
                </div>
              </div>
              <div className={'footer__wrapper__right__contact__container__item'}>
                <div className={'footer__wrapper__right__contact__container__item__left'}>
                  <img src={emailIconPath} alt={'facebook icon'} />
                </div>
                <div className={'footer__wrapper__right__contact__container__item__right'}>
                  prorequest@repairprosja.com
                </div>
              </div>
              <div className={'footer__wrapper__right__contact__container__item'}>
                <div className={'footer__wrapper__right__contact__container__item__left'}>
                  <img src={locationIconPath} alt={'facebook icon'} />
                </div>
                <div className={'footer__wrapper__right__contact__container__item__right'}>
                  Russell Heights, Kingston, Jamaica
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
